import { AddInError, Container } from '@utils-global';
import { routes } from '../constants';
import { getGraphErrorContext, withGraphRetry } from './helpers';

/** Well-known folder identifier, culture-invariant on every mailbox. */
const JUNK_FOLDER_ID = 'junkemail';

export const moveMailToSpam = async (
  mailId: string,
  userEmail: string,
  isSharedMailbox: boolean = false,
) => {
  try {
    return await withGraphRetry(
      () =>
        Container.graphClient.post(routes.office.moveMailToSpam(mailId, userEmail), {
          destinationId: JUNK_FOLDER_ID,
        }),
      { isSharedMailbox, destinationFolderId: JUNK_FOLDER_ID },
    );
  } catch (error) {
    throw new AddInError(
      'Mail could not be moved to spam',
      getGraphErrorContext(error, JUNK_FOLDER_ID),
    );
  }
};
